export const DTB_STATUSES = ['COMPLETED_ON_TIME', 'COMPLETED_LATE', 'NOT_COMPLETED', 'OVERDUE', 'CANCELLED'];
export type DTBReportResult = {
  assignmentId: string;
  assignedDate: string;
  complete: boolean;
  email: string;
  firstName: string;
  id: string;
  lastName: string;
  manual: {
    id: string;
    name: string;
  },
  policy: {
    id: string;
    number: string;
    name: string;
  },
  status: typeof DTB_STATUSES[number];
}